import axiosInstance from '../utils/axios';

const physicalStockService = {
  create: async (data) => {
    const response = await axiosInstance.post('/physical-stock', data);
    return response.data;
  },

  getById: async (id) => {
    const response = await axiosInstance.get(`/physical-stock/${id}`);
    return response.data;
  },

  getAll: async () => {
    const response = await axiosInstance.get('/physical-stock');
    return response.data;
  },
};

export default physicalStockService;
